/* COMPONENT IMPORTS*/
import DesktopNavbar from "./Navbar/DesktopNavbar";
import { Sidebar } from "./Sidebar/Sidebar";
import ContextConstructor from "./Context/Context";

/* MODULE IMPORTS */
import { Container } from "reactstrap";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "./Header/Header";
import MobileHeader from "./Header/MobileHeader";

import "./Layout.css";
import MobileNavbar from "./Sidebar/MobileNavbar";
import FloatButton from "./FloatButton/FloatButton";

class Layout extends Component {
  static displayName = Layout.name;
  state = {
    name: "",
    isCollapsed: false,
  };

  getNameCapitalize(name) {
    if (typeof name !== "string" || !name.trim()) {
      return "";
    }

    return name
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");
  }

  utf8Decode(utf8String) {
    if (typeof utf8String != "string")
      throw new TypeError("parameter 'utf8String' is not a string");
    const unicodeString = utf8String
      .replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, function (c) {
        var cc =
          ((c.charCodeAt(0) & 0x0f) << 12) |
          ((c.charCodeAt(1) & 0x3f) << 6) |
          (c.charCodeAt(2) & 0x3f);
        return String.fromCharCode(cc);
      })
      .replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (c) {
        var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
        return String.fromCharCode(cc);
      });
    return unicodeString;
  }

  populateProfileData = async () => {
    const selectedUser = this.context.selectedUser;
    if (!selectedUser || !selectedUser.name) {
      return;
    }

    const profileName = selectedUser.name;
    const profileNameUTF8 = this.getNameCapitalize(this.utf8Decode(profileName));

    this.setState({ name: profileNameUTF8 });
  };

  toggleSidebar = () => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  openProfile = () => {
    if (this.props.location.pathname !== "/profile") {
      this.props.history.push("/profile");
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth < 1670) {
      this.setState({ isCollapsed: true });
    }
  };

  render() {
    if (this.state.name === "") {
      this.populateProfileData();
    }

    const { isLoggedIn, isMobileAuth } = this.context;

    const pathname = this.props.location?.pathname || "";

    const classBeneficiosDiv =
      pathname === "/beneficios" || pathname === "/cartaoassociado" ? "beneficios-container" : "";

    if (isMobileAuth) {
      return (
        <div className="layout-wrapper">
          <DesktopNavbar />
          <div className="main-content menu-collapsed mobile-auth-content">
            {this.props.children}
          </div>
        </div>
      );
    }

    if (isLoggedIn) {
      return (
        <div className="layout-wrapper">
          <DesktopNavbar />
          <Header
            userName={this.state.name}
            openProfile={this.openProfile}
            context={this.context}
            pathname={pathname}
          />
          <MobileHeader
            userName={this.state.name}
            openProfile={this.openProfile}
            context={this.context}
            pathname={pathname}
          />

          <Sidebar
            className={`fixed-sidebar ${this.state.isCollapsed ? "collapsed" : ""}`}
            isCollapsed={this.state.isCollapsed}
            toggleSidebar={this.toggleSidebar}
          />
          <div className={`main-content ${this.state.isCollapsed ? "menu-collapsed" : ""}`}>
            <Container className={classBeneficiosDiv}>
              {this.props.children}
              {pathname !== "/profile" && <FloatButton title="Fale connosco" />}
            </Container>
          </div>
          <MobileNavbar />
        </div>
      );
    }

    return (
      <div>
        <Container>{this.props.children}</Container>
      </div>
    );
  }
}

Layout.contextType = ContextConstructor;

export default withRouter(Layout);
